@if (languageChange$ | async; as _lang) {
  <ng-container *transloco="let t">
    <div class="d-flex align-items-stretch">
      <div class="d-flex align-items-center">
        <a [routerLink]="['/', _lang, 'saved-parts', 'recent-searches']" [title]="t('label_saved_searches')" class="btn btn-icon position-relative btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px">
          <span class="svg-icon svg-icon-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.18.18 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.18.18 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.18.18 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.18.18 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.18.18 0 0 0 .134-.098z"
                fill="currentColor"
              />
              <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 0 .554 0L13 14.566V2a1 1 0 0 0-1-1z" fill="currentColor" />
            </svg>
          </span>

          <!-- Badge Counter -->
           @defer (on immediate) {
            @if (count() > 0) {
              <span class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-warning badge-sm">
                {{ count() }}
              </span>
            }
          }
        </a>
      </div>
    </div>
  </ng-container>
}
